<template>
    <main role="main">
        <article class="layout-contents-container">

            <div class="layout-page-title">
                <button class="buttons-icon" data-icon="back" data-type="line" type="button" @click="goBack()">
                    Back
                </button>
                <h1 class="page-title">
                    {{ $t('MENU.COMPLIANCE') }}
                </h1>
            </div>

            <!--Compliance Title-->
            <div class="compliance-subtitle"
                 v-bind:data-type="getComplianceInfo.cmplStat === 'F' ? 'failer' : getComplianceInfo.cmplStat === 'P' ? 'success' : getComplianceInfo.cmplStat === 'E' ? 'failer' : 'waiting'">
                <div class="policy-item">
                    <div class="badge">
                        <!--검사 상태-->
                        <span v-if="getComplianceInfo.cmplStat === 'P'" class="icon-tag"
                              data-type="success">{{ $t('COMPLIANCE.EVAL_STAT.PASSED') }}<!--성공--></span>
                        <span v-else-if="getComplianceInfo.cmplStat === 'F'" class="icon-tag"
                              data-type="failer">{{ $t('COMPLIANCE.EVAL_STAT.FAILED') }}<!--실패--></span>
                        <span v-else-if="getComplianceInfo.cmplStat === 'R'" class="icon-tag" data-icon="examining"
                              data-type="waiting">{{ $t('COMPLIANCE.EVAL_STAT.EXAMINING') }}</span>
                        <span v-else-if="getComplianceInfo.cmplStat == null" class="icon-tag" data-icon="unexamined"
                              data-type="waiting">{{ $t('COMPLIANCE.EVAL_STAT.UNEXAMINED') }}</span>

                        <!--사용자 설정-->
                        <span v-if="getComplianceInfo.userDefiYn === 'Y'" class="icon-tag"
                              data-type="policy-custom">{{ $t('TYPE.CUSTOM') }}<!--사용자 설정--></span>
                        <span v-else-if="getComplianceInfo.userDefiYn === 'N'" class="icon-tag"
                              data-type="policy-system">{{ $t('TYPE.BEST_PRACTICE') }}<!--Best practice--></span>
                    </div>

                    <h2 class="name"
                        v-bind:title="getComplianceInfo.plcyTitl ? (getComplianceInfo.userDefiYn === constants.PARAM.SELECT.N ? getComplianceInfo[`${curLang}Title`] : getComplianceInfo.plcyTitl) : ''">
                        <span
                            class="ellipsis">{{
                                getComplianceInfo.plcyTitl ? (getComplianceInfo.userDefiYn === constants.PARAM.SELECT.N ? getComplianceInfo[`${curLang}Title`] : getComplianceInfo.plcyTitl) : ''
                            }}</span>
                        <a class="buttons" data-icon-right="open" data-size="s" data-type="line"
                           v-on:click="goPolicy()">
                            <span class="open">{{ $t('COMPLIANCE.MOVE_POLICY') }}<!--정책 수정 이동--></span>
                        </a>
                    </h2>
                    <span class="count">
                            <span v-if="getComplianceInfo.cmplStat === 'F'"
                                  class="error">{{
                                    $t('COMPLIANCE.POLICY_NAME_CONTENTS_FAIL', {'fCnt': getComplianceInfo.failCnt})
                                }} / </span>
                        <!--실패 n개-->
                            {{ $t('COMPLIANCE.POLICY_NAME_CONTENTS_TOTAL', {'tCnt': getComplianceInfo.ruleCnt}) }}
                        </span>
                </div>

                <div class="actions">
                    <time v-if="getComplianceInfo.execType === 'A'" class="scheduled" datetime="">
                        {{ $t('COMPLIANCE.LABEL.NEXT_EVALUEATION') }} {{ getComplianceInfo.reservedDate }}
                    </time>
                </div>
            </div>

            <!--navigation bar-->
            <nav class="navigation-tab">
                <button class="tab-item selected" type="button"
                        >{{ $t('COMPLIANCE.TAB.EVALUATION_RESULT') }}
                        <!--검사 결과-->
                </button>
            </nav>
            <!--contents-->
            <ComplianceDetailTabResult
                :callSetSearchKey="setSearchKey"
                :callSetSortColumn="setSortColumn"
                :cmplDetail="cmplDetail"
                :ruleListData="ruleListData"
                :ruleListSearch="ruleListSearch"
                :sortColumn="sortColumn"
                :isLog="true"
                :roleCode="roleCode"
            />
        </article>
        <PopSendReport
            :userList="cmplDetail.userList"
        />
    </main>
</template>
<script>
    import ComplianceDetailTabResult from "./complianceDetailTabResult.vue";
    import PopSendReport from "../common/popSendReport.vue";
    import _ from "lodash";
    import {mapGetters} from "vuex";
export default {
    name: 'ComplianceDetailLog',
    components: {
        ComplianceDetailTabResult, PopSendReport
    },
    data() {
        return {
            cmplId: this.$route.query.cmpl,             // Compliance ID
            rsltId: this.$route.query.rslt,            // Compliance Result ID
            selectedRules: []
            , cmplInfo: {}
            , searchStat: this.constants.PARAM.SELECT.FILTER_ALL      // SearchList of Compliance Status : 처음 전체선택으로 모든 값 넣어줌
            , searchSvrty: this.constants.PARAM.SELECT.SEARCH_SEVERITY       // SearchList of Severity : 처음 전체선택으로 모든 값 넣어줌
            , sortColumn: ''
            , cmplDetail: {}
            , ruleListData: []
            , ruleListSearch: []
            , cmplSearchKey: {}
            , roleCode: null
        }
    },
    created: function () {
        this.selectActionTemplateList();
        this.getAccountList();
        // 20190714 Cateogyr, Action 에 User 표시해주려고 박은영이 추가함.
        this.selectUserList();
    },
    mounted() {
        this.slctCmplInfo('complianceDetailTabResult');
        this.slctCmplInfo();
        this.getAlertCreatePermission();
    },
    computed: {
        curLang() {
            return this.$i18n.locale;
        },
        ...mapGetters({
            curCmpnId: 'user/curCmpnId',
            siteCd: 'user/siteCd',
            loginUser: 'user/loginUser'
        }),
        getComplianceInfo: function () {
            console.log("this.cmplInfo: ", this.cmplInfo);
             return this.cmplInfo || {};
        },
        templateList: function () {
            return this.$store.state.templateList;
        },
    },
    watch: {
        ruleListData(newVal){
            this.getCtgLabelFilterData(newVal);
            if (this.templateList) {
                this.getProdFilterData(newVal);
            }
        },
        templateList() {
            if (this.ruleListData) {
                this.getProdFilterData(this.ruleListData);
            }
        },
        curCmpnId() {
            this.$router.push(`/compliance`);
        },
    },
    methods: {
        getAccountList: function () {
            let url = `/api/governance/cmpl/target/acnt`;
            let header = {
                "cmpnId": this.curCmpnId,
                "cmplId": this.$route.query.cmpl
            };
            this.http.post(url, JSON.stringify(header))
                .then(result => {
                    if (result.status === 200) {
                        let cmplDetail = {...this.cmplDetail};
                        cmplDetail.acntList = result.data.result.list ? result.data.result.list : [];
                        cmplDetail.acntListCnt = result.data.result.cnt;
                        this.cmplDetail = cmplDetail;
                        this.getRuleByKey();
                    }
                });
        },
        getProdFilterData: function (ruleListData) {
            let prodFilter = [];
            let haveManual = false;
            if (ruleListData && this.templateList) {
                ruleListData.forEach((rule)=>{
                    if (rule.autoExeYn === "Y") {
                        const conditions = rule.cndVal;
                        conditions.forEach((cnd)=>{
                            const ruleProd = _.find(this.templateList, {'tmpltId': cnd.tmpltId});
                            if (ruleProd) {
                                const val = this.$t('PRODUCT.' + ruleProd.prod);
                                const vendor = this.Common.getVendorByKey(ruleProd.vendor);
                                prodFilter.push({
                                    key: ruleProd.prod,
                                    val, vendor
                                });
                            }
                        })
                    } else {
                        haveManual = true;
                    }
                });
            }
            if (haveManual) {
                const manualProduct = {
                    key: 'manual',
                    val: this.$t('LABEL.MANUAL_RULE')
                }
                prodFilter.push(manualProduct);
            }
            const cmplDetail = {...this.cmplDetail};
            cmplDetail.prodFilterData = _.unionBy(prodFilter, 'key');
            this.cmplDetail = cmplDetail;
        },
        getCtgLabelFilterData: function (ruleListData) {
            let ctgFilter = [];
            ruleListData.forEach(function (r) {
                if (!_.isNil(r.ctgLabel)) {
                    for (let ctg of r.ctgLabel) {
                        ctgFilter.push({key: ctg, val: ctg});
                    }
                }
            })
            let cmplDetail = {...this.cmplDetail};
            cmplDetail.ctgLabelFilterData = _.unionBy(ctgFilter, 'key');
            this.cmplDetail = cmplDetail;
        },
        // 선택한 Column으로 Rule 리스트 Sorting
        setSortColumn(sortColumn) {
            const sortObject = this.Common.setSortColumn(this.sortColumn, this.sortOrder, sortColumn);
            this.sortColumn = sortObject.sortColumn;
            this.sortOrder = sortObject.sortOrder;
            this.getRuleByKey();
        },
        setSearchKey(key, value) {
            this.cmplSearchKey = {
                ...this.cmplSearchKey,
                [key]: value
            };
            this.getRuleByKey();
        },
        async slctCmplInfo(api) {
            let url = '';
            var header = {
                'cmpnId': this.curCmpnId,
                'cmplId': this.cmplId,
                'rsltId': this.rsltId
            }
            if (api && api === 'complianceDetailTabResult') {
                url = `/api/governance/compliance/result`;
                try {
                    const result = await this.http.post(url, JSON.stringify(header));
                    let cmplDetail = {...this.cmplDetail};
                    this.ruleListData = _.get(result, "data.result");
                    
                    for (let rule of this.ruleListData) {
                        rule.cndVal = rule.cndVal !== null ? JSON.parse(rule.cndVal) : null
                        rule.actnVal = rule.actnVal !== null ? JSON.parse(rule.actnVal) : null
                        rule.accAlias = rule.accAlias !== null ? rule.accAlias.split(',') : null
                        rule.ctgLabel = rule.ctgLabel !== null ? rule.ctgLabel.split("|") : null
                    }
                    //init search keys
                    cmplDetail.rsltId = this.rsltId;
                    cmplDetail.searchTxt = "";
                    cmplDetail.searchCtg = [];
                    cmplDetail.searchProd = [];
                    this.cmplDetail = cmplDetail;
                    this.getRuleByKey();
                } catch (err) {
                    console.error("slctCmplInfo: " + err);
                }
            } else {
                url = `/api/governance/compliance/info`;
                try {
                    const response = await this.http.post(url, JSON.stringify(header));
                    this.cmplInfo = _.get(response, "data.result");
                    this.$nextTick(function () {
                        let self = this;
                        setTimeout(function () {
                            self.initView();
                        }, 10);
                    });
                } catch (e) {
                    console.error("slctCmplInfo: " + e);
                }
            }
        },
        getRuleByKey() {
            const {searchTxt, searchProd, searchCtg} = this.cmplSearchKey;
            const self = this;
            // Search를 위해 원본 Response 데이터는 유지하여 cloneDeep copy
            let listInfo = _.cloneDeep(this.ruleListData);
            if (!listInfo[0] || listInfo[0].cndVal == null) { // rule 등록되지 않은 것 처리
                return [];
            }
            listInfo = _.forEach(listInfo, function (o) {
                _.forEach(o.cndVal, function (k) {
                    let ruleProd = _.find(self.templateList, {'tmpltId': k.tmpltId})
                    if (typeof (ruleProd) !== 'undefined') {
                        // o.prodNm = self.$t('PRODUCT.'+ruleProd.prod)
                        o.prodNm = ruleProd.prod
                    }

                })
            })
            /* Filter 처리 */
            // Text filter
            if (typeof (searchTxt) !== 'undefined' && searchTxt !== '') {
                try {
                    listInfo = listInfo.filter(item => {
                        let ruleTitle = item[`${this.curLang}RuleTitle`];
                        if (ruleTitle) {
                            ruleTitle = item[`${this.curLang}RuleTitle`].toLocaleLowerCase();
                        } else {
                            ruleTitle = item.ruleTitl;
                        }  
                        ruleTitle = ruleTitle.toLocaleLowerCase();
                        return ruleTitle.includes(searchTxt.toLocaleLowerCase())}
                    );
                } catch (err) {
                    console.error("complianceDetail: ", err);
                }
            }
            // Category filter
            if (typeof (searchCtg) !== 'undefined' && searchCtg.length > 0) {
                listInfo = _.filter(listInfo, function (o) {
                    for (let srchCtg of searchCtg) {
                        if (_.includes(o.ctgLabel, srchCtg)) {
                            return true
                        }
                    }
                    return false
                })
            }
            // Product filter
            if (typeof (searchProd) !== 'undefined' && searchProd.length > 0) {
                let manualRules = [];
                if (searchProd.includes('manual')) {
                    manualRules = _.cloneDeep(_.filter(listInfo, {'autoExeYn': 'N'}));
                }
                listInfo = _.filter(listInfo, function (o) {
                    let fill = _.filter(o.cndVal, function (k) {
                        let ruleProd = _.find(self.templateList, {'tmpltId': k.tmpltId})
                        for (let srchProd of searchProd) {
                            if (ruleProd && ruleProd.prod === srchProd) {
                                return true;
                            }
                        }
                        return false;
                    });
                    return fill.length > 0;
                })
                listInfo = listInfo.concat(manualRules);
            }
            // 검사 상태별 필터 선택 시
            if (this.searchStat.length !== this.constants.COMPLIANCE_STAT_FILTER.length) {
                listInfo = listInfo.filter((p) => {
                    let value = false;
                    // 실패(해결됨)
                    if (_.includes(this.searchStat, this.constants.COMPLIANCE_STAT.FAIL_SOLVED)) {
                        if (p.ruleCmplRslt === this.constants.COMPLIANCE_STAT.FAIL && p.execYn === 'Y') {
                            value = true;
                        }
                    }
                    // 실패(미해결)
                    if (_.includes(this.searchStat, this.constants.COMPLIANCE_STAT.FAIL_UNSOLVED)) {
                        if (p.ruleCmplRslt === this.constants.COMPLIANCE_STAT.FAIL && p.execYn === 'N') {
                            value = true;
                        }
                    }
                    // 나머지 case
                    if (_.includes(this.searchStat, p.ruleCmplRslt)) {
                        value = true;
                    }
                    return value;
                })
            }
            // 심각도 필터 선택 시
            if (this.searchSvrty.length !== this.constants.SVRTY_FILTER.length) {
                listInfo = listInfo.filter((p) => {
                    return _.includes(this.searchSvrty, p.svrty)
                })
            }

            // Sorting 처리
            if (this.sortColumn !== '' && this.sortOrder !== '') {
                listInfo = _.orderBy(listInfo, [self.sortColumn], [self.sortOrder])
            }

            if (listInfo !== null) {
                this.searchCnt = listInfo.length
            }

            // Action 없는 Rule 처리
            _.forEach(listInfo, function (rule) {
                _.forEach(rule.actnVal, function (actn) {
                    if (actn.actnId !== null && actn.actnId !== self.constants.PARAM.SELECT.NONE) {
                        rule.availAction = true
                        return false
                    }
                })
            })
            this.ruleListSearch = listInfo;
        },
        // Action 목록 조회
        selectActionTemplateList() {
            // Action List 초기화
            var url = `/api/governance/actn`;
            this.http.get(url)
                .then(response => {
                    let cmplDetail = {...this.cmplDetail};
                    cmplDetail.actionTemplateList = response.data.result;
                    this.cmplDetail = cmplDetail;
                });
        },
        // Action Email 에서 사용할 사용자 List 가져오기
        selectUserList() {
            var url = `/api/governance/user/list`;
            var header = {
                'cmpnId': this.curCmpnId
            };

            this.http.post(url, header)
                .then(response => {
                    if (response.data.status === 'ok') {
                        let cmplDetail = {...this.cmplDetail};
                        cmplDetail.userList = response.data.result;
                        this.cmplDetail = cmplDetail;
                    }
                });
        },

        downloadReport: function () {
            // TODO : 하나의 compliance만 report 보내도록 수정 필요
            this.Common.viewPopup('popup-send-report-email');
        },
        goBack() {
            this.$router.back();
        },
        // 해당 Policy Management 화면으로 이동
        goPolicy() {
            const url = "/policy/detail";
            this.$router.push({path: url, query: {rvsn: this.getComplianceInfo.rvsnId}});
        },
        initView: function () {

            // 복사/삭제/히스토리보기 ... 메뉴 Script
            var $moreActions = $('[data-trigger="management"]');
            $moreActions.tooltipster({
                animation: 'fade',
                side: 'bottom',
                theme: 'go-actions',
                interactive: true,
                trigger: 'click',
                arrow: false,
                functionBefore: function (instance, helper) {
                    $(helper.origin).addClass("selected");
                },
                functionAfter: function (instance, helper) {
                    $(helper.origin).removeClass("selected");
                },
                functionPosition: function (instance, helper, position) {
                    position.coord.top = position.coord.top -= 7;
                    position.coord.left = helper.geo.origin.offset.right - position.size.width;
                    return position;
                }
            });
            // 복사/삭제/히스토리보기 ... 메뉴 Script
        },
        async getAlertCreatePermission() {
            const url = `/api/external/${this.curCmpnId}/${this.loginUser.userId}/role`;
            const response = await this.http.get(url);
            
            const roleCode = _.get(response, "data.data.roleCode");
            this.roleCode = roleCode;
        }
    },
    beforeDestroy() {
        $('body').removeClass('compliance');
    }
}
</script>
<style scoped>
.buttons[data-type=line]{
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/compliance/ComplianceDetailLog.vue